import { useTranslation } from "react-i18next";

import { staticStates } from "@/constants/StaticStates";

export const useStaticStatesFilter = (type) => {
  const { t } = useTranslation();

  return {
    filterMode: "tree",
    filters: staticStates[type]?.map(({ key }) => {
      return {
        text: t(`${type}:staticState:${key}`),
        value: key,
      };
    }),
  };
};
